<div class="settings-shell">
  @if (title().length > 0) {
    <div class="header-area fieldset-style">
      <div class="headline">
        <h3>{{ title() }}</h3>
      </div>
    </div>
  }
  <div class="content-area fieldset-style">
    <div class="scroll-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
  @if (hasActions()) {
    <div class="actions-area fieldset-style">
      <ng-content select="[actions]"></ng-content>
    </div>
  }
</div>
